// extracted by mini-css-extract-plugin
export default {"dialogHeaderContainer":"_UJGyb","mainTitle":"uDyD7q"};